import { render, staticRenderFns } from "./talk_allfagao.vue?vue&type=template&id=ddfd40a4&scoped=true&"
import script from "./talk_allfagao.vue?vue&type=script&lang=js&"
export * from "./talk_allfagao.vue?vue&type=script&lang=js&"
import style0 from "./talk_allfagao.vue?vue&type=style&index=0&id=ddfd40a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfd40a4",
  null
  
)

export default component.exports